/**
 * Mimesa's tunables.
 */
const MIMESA_CONFIG = Object.freeze({
    // Inventory expiration dates (store check / store detail): a product expiring within this
    // many days gets the warning tag; an expired one the danger tag.
    expiryWarningDays: 30,
    // Store types priced by their client's list instead of the store type's (the API has no
    // per-store price resolver; see data.controller.js fetchPricesForStoreByType).
    modernStoreTypes: Object.freeze(['nacional', 'regional', 'independiente']),
});

export default MIMESA_CONFIG;
